<style scoped lang="scss" type="text/scss">
    .image-download-panel-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 5rem;
        box-sizing: border-box;
        height: 2rem;
        font-size: .75rem;
        background-color: #417DFF;
        color: #FFF;
        transition: all .2s;
        border-bottom-left-radius: .15rem;
        border-bottom-right-radius: .15rem;

        .icon {
            margin-right: .25rem;
        }

        &:hover {
            cursor: pointer;
            transform: scale(1.1);
        }
    }
</style>

<style lang="scss" type="text/scss">
    .download-panel.radio-boxes {
        width: 13rem;

        .vertical-check-item-group {
            width: 100%;

            .vertical-check-item {
                margin-top: .25rem;
                width: 100%;

                &:first-of-type {
                    margin-top: 0;
                }
            }
        }
    }
</style>

<template>
    <el-popover
            placement="bottom"
            trigger="click">
        <div class="download-panel radio-boxes">
            <el-radio-group class="vertical-check-item-group" v-model="targetSpecialCompetitionId" size="small">
                <el-radio v-for="item in specialCompetitions" :key="item.id"
                          class="vertical-check-item"
                          :label="item.id" border>
                    {{ item.name }}.xls
                </el-radio>
            </el-radio-group>
            <el-button type="primary" plain style="width: 100%; margin-top: .25rem" size="mini"
                       @click="download" :loading="requesting" :disabled="targetSpecialCompetitionId === null"
            >
                确认导出
            </el-button>
        </div>

        <div class="image-download-panel-container" slot="reference">
            <i class="icon">&#xe6b0;</i>
            <span>文件导出</span>
        </div>
    </el-popover>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
                requesting: false,
                option: {
                    schoolBadge: true
                },
                targetSpecialCompetitionId: null
            };
        },
        computed: {
            specialCompetitions () {
                return this.$store.state.competition.specialCompetitions;
            },
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler () {
                    this.targetSpecialCompetitionId = null;
                }
            }
        },
        methods: {
            download () {
                if (this.targetSpecialCompetitionId === null) return;
                this.$normalRequest('player/downloadSpecialCompetitionRegisteredPlayersDataZip', {
                    special_competition_id: this.targetSpecialCompetitionId
                }, false, true, this, 'requesting').then(data => {
                    this.$download(data);
                }).catch(_ => {
                });
            }
        }
    };
</script>
